import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form } from 'antd';
import Card from '../../components/Card';
import TEXT from '../../components/Text';
import { InputSearch, RangePicker, InputSelect } from '../../components/FormFields';
import UsersList from '../../components/UsersList';
import Pagination from '../../components/Pagination';
import UserInfoModal from '../../components/UserInfoModal';
import AddUserModal from '../../components/AddUserModal';
import { ButtonPrimary } from '../../components/Button';
import { getAdminUsers, updateAdminUser } from "../../../redux/actions/adminPanel/adminUsers";
import { getAdminUsersEmailsList } from '../../../redux/actions/adminPanel/adminUsersEmailsDownload';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import qs from 'qs';
import moment from 'moment';
import { setAdminFiltersUsers } from '../../../redux/actions/adminPanel/adminPageFilters';
import { scrollContainerIntoView } from '../../helpers/scrollIntoView';
import './style.scss';
import { identity } from '../../../utils/getIdentity';
import { sanitizeSearchInputDisable } from '../../../utils/sanitizeInput';
import { getRolesList } from "../../../redux/actions/adminPanel/adminSettings";
import { useTranslation } from "react-i18next";


const Users = ({
  usersList,
  usersCurrentPage,
  totalUsers,
  usersFetching,
  getAdminUsers,
  getAdminUsersEmailsList,
  emailsFetching,
  setAdminFiltersUsers,
  adminFiltersUsers,
  permissions,
  rolesList,
  getRolesList,
  updateAdminUser,
  role
}) => {
  const [form] = Form.useForm();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [sort, setSort] = useState(adminFiltersUsers?.sort || undefined);
  const [order, setOrder] = useState(adminFiltersUsers?.order || 'DESC');
  const [formValues, setFormValues] = useState(null);
  const [sortRole, setSortRole] = useState(adminFiltersUsers?.role || undefined);
  const [sortProfile, setSortProfile] = useState(adminFiltersUsers?.active ?? undefined);
  const [selectedOrder, setSelectedOrder] = useState(adminFiltersUsers?.order || undefined);
  const [selectedAgent, setSelectedAgent] = useState(adminFiltersUsers?.agent || undefined);
  const [transactionsFilter, setTransactionsFilter] = useState(undefined);
  const [limit, setLimit] = useState(10);
  const history = useHistory();
  const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
  let dateParam = undefined;
  if (Object.keys(query).length !== 0 && query.constructor === Object) {
    dateParam = query;
  }
  const adminUsersRef = useRef(null);
  const currentRole = localStorage.getItem('role');

  const { t } = useTranslation();

  useEffect(() => {
    if (permissions?.length && permissions[2]?.view) {
      getRolesList();
    }
  }, [permissions])

  useEffect(() => {
    if (!adminFiltersUsers) {
      getAdminUsers({
        dateOfSignUp: dateParam ? [moment.utc(dateParam?.from), moment.utc(dateParam?.to)] : undefined,
        agent: selectedAgent ? 'panther' : undefined,
        search: undefined,
        limit,
        totalSort: transactionsFilter
      });
      return;
    }

    getAdminUsers({ ...adminFiltersUsers, limit, agent: selectedAgent ? 'panther' : undefined, totalSort: transactionsFilter });
  }, []);

  useEffect(() => {
    scrollContainerIntoView(adminUsersRef);
  }, []);
  // scroll to top when you change pagination
  useEffect(() => {
    scrollContainerIntoView(adminUsersRef);
    setAdminFiltersUsers({page: +usersCurrentPage});
  }, [usersCurrentPage]);

  const sortUsersByBalanceRequest = (order, sortBalance) => {
    getAdminUsers({
      ...form.getFieldsValue(true),
      agent: selectedAgent ? 'panther' : undefined,
      sort: sortBalance,
      page: +usersCurrentPage,
      order,
      limit,
      role: currentRole || sortRole,
      active: sortProfile,
      totalSort: transactionsFilter
    });
    setAdminFiltersUsers({ order: order, sort: sortBalance });
  };

  const sortUsersByRoleRequest = role => {
    getAdminUsers({
      ...form.getFieldsValue(true),
      agent: selectedAgent ? 'panther' : undefined,
      role: role,
      page: 1,
      order,
      sort,
      limit,
      active: sortProfile,
      totalSort: transactionsFilter
    });
    setAdminFiltersUsers({ role: role });
  };

  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem('role')
    }, 1000)
  }, []);

  const sortUsersByactiveRequest = active => {

    getAdminUsers({
      ...form.getFieldsValue(true),
      agent: selectedAgent ? 'panther' : undefined,
      active: active,
      role: currentRole || sortRole,
      page: +usersCurrentPage,
      order,
      sort,
      limit,
      totalSort: transactionsFilter
    });
    setAdminFiltersUsers({ active: active });
  };

  useEffect(() => {
    getAdminUsers({
      ...form.getFieldsValue(true),
      agent: selectedAgent ? 'panther' : undefined,
      active: sortProfile,
      role: currentRole || sortRole,
      page: +usersCurrentPage,
      order,
      sort,
      limit,
      totalSort: transactionsFilter
    });
  }, [transactionsFilter, selectedAgent])

  const dateOfSignUpDateParams = dateParam
    ? [moment.utc(dateParam.from), moment.utc(dateParam.to)]
    : adminFiltersUsers?.dateOfSignUp || null;

  return (
    <>
      <div className="admin-users" ref={adminUsersRef}>
        <Card>
          <TEXT.pageTitle>{t('admin.users_list')}</TEXT.pageTitle>
          <Form
            form={form}
            name="admin-users-form"
            initialValues={{
              search: adminFiltersUsers?.search || '',
              dateOfSignUp: dateOfSignUpDateParams,
              dateOfSignIn: adminFiltersUsers?.dateOfSignIn || null,
              emailConfirmed: adminFiltersUsers?.emailConfirmed || undefined,
            }}
            onFieldsChange={() => setFormValues(form.getFieldsValue(true))}
            onFinish={() => {
              getAdminUsers({
                ...form.getFieldsValue(true),
                agent: selectedAgent ? 'panther' : undefined,
                sort,
                page: 1,
                order,
                limit,
                role: sortRole,
                active: sortProfile,
                totalSort: transactionsFilter
              });
              setAdminFiltersUsers({ ...form.getFieldsValue(true) });
            }}
          >
            <div className={`admin-users__filters admin-users__filters-${identity}`}>
              <InputSearch
                name="search"
                onSearch={() => {
                  const searchWords = form?.getFieldsValue()?.search
                  if (searchWords) {
                    !sanitizeSearchInputDisable(searchWords) && localStorage.setItem('searchForUsers', searchWords);
                    !sanitizeSearchInputDisable(searchWords) && form.submit();

                   if (sanitizeSearchInputDisable(searchWords)) {
                    form.resetFields();
                    form.setFieldsValue({ search: '' });
                    form.submit();
                   }
                  }
                }}
                onReset={() => {
                  localStorage.removeItem('searchForUsers');
                  form.resetFields();
                  form.setFieldsValue({ search: '' });
                  form.submit();
                }}
              />
              <RangePicker
                name="dateOfSignUp"
                placeholder={t('admin.choose_date')}
                submitAction={form.submit}
                formValues={formValues}
                withInitial={dateParam || adminFiltersUsers?.dateOfSignUp}
                clearAction={() => {
                  form.setFieldsValue({ dateOfSignUp: '' });
                  setAdminFiltersUsers({ dateOfSignUp: '' });
                }}
              />
              <RangePicker
                name="dateOfSignIn"
                placeholder={t('admin.choose_last_login')}
                submitAction={form.submit}
                formValues={formValues}
                withInitial={adminFiltersUsers?.dateOfSignIn}
                clearAction={() => {
                  form.setFieldsValue({ dateOfSignIn: '' });
                  setAdminFiltersUsers({ dateOfSignIn: '' });
                }}
              />
              <InputSelect
                name="emailConfirmed"
                dropdownMatchSelectWidth={false}
                placeholder={t('admin.choose_user_status')}
                options={[
                  { value: 'true', label: t('admin.email_confirmed') },
                  { value: 'false', label: t('admin.email_not_confirmed') },
                  { value: null, label: t('admin.email_all') },
                ]}
                onChange={form.submit}
                style={{
                  width: 180,
                }}
                className="search-email"
              />
              <div className="admin-users__add-user__button-container">
                <ButtonPrimary
                  className="admin-users__add-user-button"
                  onClick={() => setShowAddUserModal(true)}
                  disabled={permissions && permissions?.length > 0 && !permissions[1]?.edit}
                >
                  {t('admin.add_user')}
                </ButtonPrimary>
                <ButtonPrimary
                  className={`admin-users__add-user-button admin-users__add-user-button__download-emails admin-users__add-user-button__download-emails-${identity}`}
                  onClick={() => {
                    getAdminUsersEmailsList({
                      ...form.getFieldsValue(true),
                      sort,
                      order,
                      role: sortRole || undefined,
                      active: sortProfile,
                    });
                  }}
                  disabled={permissions && permissions?.length > 0 && !permissions[1]?.edit}
                >
                  {!emailsFetching ? (
                    t('admin.export')
                  ) : (
                    <div className="admin-users__loader">
                      <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 16 }} spin />} />
                    </div>
                  )}
                </ButtonPrimary>
              </div>
            </div>
            <UsersList
              role={role}
              usersList={usersList}
              permissions={permissions}
              setSelectedUserId={setSelectedUserId}
              usersFetching={usersFetching}
              handleClick={(order, sortBalance) => {
                sortUsersByBalanceRequest(order, sortBalance);
                setSort(sortBalance);
                setOrder(order);
                setSelectedOrder(order);
              }}
              selectedAgent={selectedAgent}
              handleClickSort={role => {
                sortUsersByRoleRequest(role);
                setSortRole(role);
              }}
              handleClickProfile={active => {
                sortUsersByactiveRequest(active);
                setSortProfile(active);
              }}
              handleClickAgent={agent => {
                setSelectedAgent(agent);
              }}
              setSortRole={setSortRole}
              sortRole={sortRole}
              setSortProfile={setSortProfile}
              sortProfile={sortProfile}
              setSortBalance={setSort}
              setSelectedOrder={setSelectedOrder}
              selectedOrder={selectedOrder}
              rolesList={rolesList}
              updateAdminUser={updateAdminUser}
              getAdminUsers={() => {
                getAdminUsers({
                  ...form.getFieldsValue(true),
                  agent: selectedAgent ? 'panther' : undefined,
                  sort,
                  page: +usersCurrentPage,
                  order,
                  limit,
                  role: currentRole || sortRole,
                  active: sortProfile,
                  totalSort: transactionsFilter
                })
              }}
              transactionsFilter={transactionsFilter}
              setTransactionsFilter={setTransactionsFilter}
            />
            {usersList.length ? (
              <Pagination
                current={+usersCurrentPage}
                total={totalUsers}
                getEntities={props => {
                  setLimit(props?.limit);
                  getAdminUsers({ ...props, agent: selectedAgent ? 'panther' : undefined, order, sort, role: sortRole, active: sortProfile, totalSort: transactionsFilter })
                }}
                getFormValues={form.getFieldsValue}
              />
            ) : null}
          </Form>
        </Card>
      </div>
      <UserInfoModal selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} />
      <AddUserModal
        showAddUserModal={showAddUserModal}
        setShowAddUserModal={setShowAddUserModal}
        updateUsersList={() => form.submit()}
      />
    </>
  );
};

const mapStateToProps = state => ({
  usersList: state.adminUsers.entities,
  role: state.adminUsers.role,
  usersCurrentPage: state.adminUsers.page,
  totalUsers: state.adminUsers.countItems,
  usersFetching: state.adminUsers.fetching,
  emailsFetching: state.adminUsersEmailsDownload.fetching,
  adminFiltersUsers: state.adminFilters.users,
  permissions: state.adminSettings.permissions,
  rolesList: state.adminSettings.rolesList,
});

const mapDispatchToProps = {
  getAdminUsers,
  getAdminUsersEmailsList,
  setAdminFiltersUsers,
  getRolesList,
  updateAdminUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
